import ApiService from './ApiService';

const ApprovalsService = {
  list: (status, limit = 50) => ApiService.get('/approvals', { status, limit }),
  approve: (id, grants) => ApiService.post(`/approvals/${id}/approve`, grants ? { grants } : undefined),
  reject: (id) => ApiService.post(`/approvals/${id}/reject`),
};

export default ApprovalsService;
